/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PersonalInformationRouteImport } from './routes/personal-information'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DataAndPrivacyRouteImport } from './routes/data-and-privacy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as WorkspacesRouteRouteImport } from './routes/workspaces/route'
import { Route as KnowledgeRouteRouteImport } from './routes/knowledge/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspacesIndexRouteImport } from './routes/workspaces/index'
import { Route as KnowledgeIndexRouteImport } from './routes/knowledge/index'
import { Route as BillingIndexRouteImport } from './routes/billing/index'
import { Route as BillingCallbackRouteImport } from './routes/billing/callback'
import { Route as WorkspacesWorkspaceIdRouteRouteImport } from './routes/workspaces/$workspaceId/route'
import { Route as KnowledgeWorkspaceIdRouteRouteImport } from './routes/knowledge/$workspaceId/route'
import { Route as KnowledgeWorkspaceIdIndexRouteImport } from './routes/knowledge/$workspaceId/index'
import { Route as WorkspacesWorkspaceIdSettingsRouteImport } from './routes/workspaces/$workspaceId/settings'
import { Route as KnowledgeCCollectionSlugRouteImport } from './routes/knowledge/c.$collectionSlug'
import { Route as KnowledgeAArticleSlugRouteImport } from './routes/knowledge/a.$articleSlug'
import { Route as KnowledgeWorkspaceIdSettingsRouteImport } from './routes/knowledge/$workspaceId/settings'
import { Route as KnowledgeWorkspaceIdArticleIdRouteImport } from './routes/knowledge/$workspaceId/$articleId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalInformationRoute = PersonalInformationRouteImport.update({
  id: '/personal-information',
  path: '/personal-information',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DataAndPrivacyRoute = DataAndPrivacyRouteImport.update({
  id: '/data-and-privacy',
  path: '/data-and-privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesRouteRoute = WorkspacesRouteRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRouteRoute = KnowledgeRouteRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIndexRoute = WorkspacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspacesRouteRoute,
} as any)
const KnowledgeIndexRoute = KnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KnowledgeRouteRoute,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingCallbackRoute = BillingCallbackRouteImport.update({
  id: '/billing/callback',
  path: '/billing/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesWorkspaceIdRouteRoute =
  WorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => WorkspacesRouteRoute,
  } as any)
const KnowledgeWorkspaceIdRouteRoute =
  KnowledgeWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => KnowledgeRouteRoute,
  } as any)
const KnowledgeWorkspaceIdIndexRoute =
  KnowledgeWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => KnowledgeWorkspaceIdRouteRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsRoute =
  WorkspacesWorkspaceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRouteRoute,
  } as any)
const KnowledgeCCollectionSlugRoute =
  KnowledgeCCollectionSlugRouteImport.update({
    id: '/c/$collectionSlug',
    path: '/c/$collectionSlug',
    getParentRoute: () => KnowledgeRouteRoute,
  } as any)
const KnowledgeAArticleSlugRoute = KnowledgeAArticleSlugRouteImport.update({
  id: '/a/$articleSlug',
  path: '/a/$articleSlug',
  getParentRoute: () => KnowledgeRouteRoute,
} as any)
const KnowledgeWorkspaceIdSettingsRoute =
  KnowledgeWorkspaceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => KnowledgeWorkspaceIdRouteRoute,
  } as any)
const KnowledgeWorkspaceIdArticleIdRoute =
  KnowledgeWorkspaceIdArticleIdRouteImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => KnowledgeWorkspaceIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRouteRouteWithChildren
  '/workspaces': typeof WorkspacesRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/data-and-privacy': typeof DataAndPrivacyRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/personal-information': typeof PersonalInformationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/knowledge/$workspaceId': typeof KnowledgeWorkspaceIdRouteRouteWithChildren
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  '/billing/callback': typeof BillingCallbackRoute
  '/billing/': typeof BillingIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/knowledge/$workspaceId/$articleId': typeof KnowledgeWorkspaceIdArticleIdRoute
  '/knowledge/$workspaceId/settings': typeof KnowledgeWorkspaceIdSettingsRoute
  '/knowledge/a/$articleSlug': typeof KnowledgeAArticleSlugRoute
  '/knowledge/c/$collectionSlug': typeof KnowledgeCCollectionSlugRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRoute
  '/knowledge/$workspaceId/': typeof KnowledgeWorkspaceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/data-and-privacy': typeof DataAndPrivacyRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/personal-information': typeof PersonalInformationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  '/billing/callback': typeof BillingCallbackRoute
  '/billing': typeof BillingIndexRoute
  '/knowledge': typeof KnowledgeIndexRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/knowledge/$workspaceId/$articleId': typeof KnowledgeWorkspaceIdArticleIdRoute
  '/knowledge/$workspaceId/settings': typeof KnowledgeWorkspaceIdSettingsRoute
  '/knowledge/a/$articleSlug': typeof KnowledgeAArticleSlugRoute
  '/knowledge/c/$collectionSlug': typeof KnowledgeCCollectionSlugRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRoute
  '/knowledge/$workspaceId': typeof KnowledgeWorkspaceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/knowledge': typeof KnowledgeRouteRouteWithChildren
  '/workspaces': typeof WorkspacesRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/data-and-privacy': typeof DataAndPrivacyRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/personal-information': typeof PersonalInformationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/knowledge/$workspaceId': typeof KnowledgeWorkspaceIdRouteRouteWithChildren
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  '/billing/callback': typeof BillingCallbackRoute
  '/billing/': typeof BillingIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/knowledge/$workspaceId/$articleId': typeof KnowledgeWorkspaceIdArticleIdRoute
  '/knowledge/$workspaceId/settings': typeof KnowledgeWorkspaceIdSettingsRoute
  '/knowledge/a/$articleSlug': typeof KnowledgeAArticleSlugRoute
  '/knowledge/c/$collectionSlug': typeof KnowledgeCCollectionSlugRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRoute
  '/knowledge/$workspaceId/': typeof KnowledgeWorkspaceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/knowledge'
    | '/workspaces'
    | '/about'
    | '/data-and-privacy'
    | '/forgot-password'
    | '/login'
    | '/personal-information'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/knowledge/$workspaceId'
    | '/workspaces/$workspaceId'
    | '/billing/callback'
    | '/billing/'
    | '/knowledge/'
    | '/workspaces/'
    | '/knowledge/$workspaceId/$articleId'
    | '/knowledge/$workspaceId/settings'
    | '/knowledge/a/$articleSlug'
    | '/knowledge/c/$collectionSlug'
    | '/workspaces/$workspaceId/settings'
    | '/knowledge/$workspaceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/data-and-privacy'
    | '/forgot-password'
    | '/login'
    | '/personal-information'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/workspaces/$workspaceId'
    | '/billing/callback'
    | '/billing'
    | '/knowledge'
    | '/workspaces'
    | '/knowledge/$workspaceId/$articleId'
    | '/knowledge/$workspaceId/settings'
    | '/knowledge/a/$articleSlug'
    | '/knowledge/c/$collectionSlug'
    | '/workspaces/$workspaceId/settings'
    | '/knowledge/$workspaceId'
  id:
    | '__root__'
    | '/'
    | '/knowledge'
    | '/workspaces'
    | '/about'
    | '/data-and-privacy'
    | '/forgot-password'
    | '/login'
    | '/personal-information'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/knowledge/$workspaceId'
    | '/workspaces/$workspaceId'
    | '/billing/callback'
    | '/billing/'
    | '/knowledge/'
    | '/workspaces/'
    | '/knowledge/$workspaceId/$articleId'
    | '/knowledge/$workspaceId/settings'
    | '/knowledge/a/$articleSlug'
    | '/knowledge/c/$collectionSlug'
    | '/workspaces/$workspaceId/settings'
    | '/knowledge/$workspaceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KnowledgeRouteRoute: typeof KnowledgeRouteRouteWithChildren
  WorkspacesRouteRoute: typeof WorkspacesRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  DataAndPrivacyRoute: typeof DataAndPrivacyRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PersonalInformationRoute: typeof PersonalInformationRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  BillingCallbackRoute: typeof BillingCallbackRoute
  BillingIndexRoute: typeof BillingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal-information': {
      id: '/personal-information'
      path: '/personal-information'
      fullPath: '/personal-information'
      preLoaderRoute: typeof PersonalInformationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-and-privacy': {
      id: '/data-and-privacy'
      path: '/data-and-privacy'
      fullPath: '/data-and-privacy'
      preLoaderRoute: typeof DataAndPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces': {
      id: '/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof WorkspacesIndexRouteImport
      parentRoute: typeof WorkspacesRouteRoute
    }
    '/knowledge/': {
      id: '/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof KnowledgeIndexRouteImport
      parentRoute: typeof KnowledgeRouteRoute
    }
    '/billing/': {
      id: '/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/callback': {
      id: '/billing/callback'
      path: '/billing/callback'
      fullPath: '/billing/callback'
      preLoaderRoute: typeof BillingCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$workspaceId': {
      id: '/workspaces/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof WorkspacesRouteRoute
    }
    '/knowledge/$workspaceId': {
      id: '/knowledge/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/knowledge/$workspaceId'
      preLoaderRoute: typeof KnowledgeWorkspaceIdRouteRouteImport
      parentRoute: typeof KnowledgeRouteRoute
    }
    '/knowledge/$workspaceId/': {
      id: '/knowledge/$workspaceId/'
      path: '/'
      fullPath: '/knowledge/$workspaceId/'
      preLoaderRoute: typeof KnowledgeWorkspaceIdIndexRouteImport
      parentRoute: typeof KnowledgeWorkspaceIdRouteRoute
    }
    '/workspaces/$workspaceId/settings': {
      id: '/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRouteRoute
    }
    '/knowledge/c/$collectionSlug': {
      id: '/knowledge/c/$collectionSlug'
      path: '/c/$collectionSlug'
      fullPath: '/knowledge/c/$collectionSlug'
      preLoaderRoute: typeof KnowledgeCCollectionSlugRouteImport
      parentRoute: typeof KnowledgeRouteRoute
    }
    '/knowledge/a/$articleSlug': {
      id: '/knowledge/a/$articleSlug'
      path: '/a/$articleSlug'
      fullPath: '/knowledge/a/$articleSlug'
      preLoaderRoute: typeof KnowledgeAArticleSlugRouteImport
      parentRoute: typeof KnowledgeRouteRoute
    }
    '/knowledge/$workspaceId/settings': {
      id: '/knowledge/$workspaceId/settings'
      path: '/settings'
      fullPath: '/knowledge/$workspaceId/settings'
      preLoaderRoute: typeof KnowledgeWorkspaceIdSettingsRouteImport
      parentRoute: typeof KnowledgeWorkspaceIdRouteRoute
    }
    '/knowledge/$workspaceId/$articleId': {
      id: '/knowledge/$workspaceId/$articleId'
      path: '/$articleId'
      fullPath: '/knowledge/$workspaceId/$articleId'
      preLoaderRoute: typeof KnowledgeWorkspaceIdArticleIdRouteImport
      parentRoute: typeof KnowledgeWorkspaceIdRouteRoute
    }
  }
}

interface KnowledgeWorkspaceIdRouteRouteChildren {
  KnowledgeWorkspaceIdArticleIdRoute: typeof KnowledgeWorkspaceIdArticleIdRoute
  KnowledgeWorkspaceIdSettingsRoute: typeof KnowledgeWorkspaceIdSettingsRoute
  KnowledgeWorkspaceIdIndexRoute: typeof KnowledgeWorkspaceIdIndexRoute
}

const KnowledgeWorkspaceIdRouteRouteChildren: KnowledgeWorkspaceIdRouteRouteChildren =
  {
    KnowledgeWorkspaceIdArticleIdRoute: KnowledgeWorkspaceIdArticleIdRoute,
    KnowledgeWorkspaceIdSettingsRoute: KnowledgeWorkspaceIdSettingsRoute,
    KnowledgeWorkspaceIdIndexRoute: KnowledgeWorkspaceIdIndexRoute,
  }

const KnowledgeWorkspaceIdRouteRouteWithChildren =
  KnowledgeWorkspaceIdRouteRoute._addFileChildren(
    KnowledgeWorkspaceIdRouteRouteChildren,
  )

interface KnowledgeRouteRouteChildren {
  KnowledgeWorkspaceIdRouteRoute: typeof KnowledgeWorkspaceIdRouteRouteWithChildren
  KnowledgeIndexRoute: typeof KnowledgeIndexRoute
  KnowledgeAArticleSlugRoute: typeof KnowledgeAArticleSlugRoute
  KnowledgeCCollectionSlugRoute: typeof KnowledgeCCollectionSlugRoute
}

const KnowledgeRouteRouteChildren: KnowledgeRouteRouteChildren = {
  KnowledgeWorkspaceIdRouteRoute: KnowledgeWorkspaceIdRouteRouteWithChildren,
  KnowledgeIndexRoute: KnowledgeIndexRoute,
  KnowledgeAArticleSlugRoute: KnowledgeAArticleSlugRoute,
  KnowledgeCCollectionSlugRoute: KnowledgeCCollectionSlugRoute,
}

const KnowledgeRouteRouteWithChildren = KnowledgeRouteRoute._addFileChildren(
  KnowledgeRouteRouteChildren,
)

interface WorkspacesWorkspaceIdRouteRouteChildren {
  WorkspacesWorkspaceIdSettingsRoute: typeof WorkspacesWorkspaceIdSettingsRoute
}

const WorkspacesWorkspaceIdRouteRouteChildren: WorkspacesWorkspaceIdRouteRouteChildren =
  {
    WorkspacesWorkspaceIdSettingsRoute: WorkspacesWorkspaceIdSettingsRoute,
  }

const WorkspacesWorkspaceIdRouteRouteWithChildren =
  WorkspacesWorkspaceIdRouteRoute._addFileChildren(
    WorkspacesWorkspaceIdRouteRouteChildren,
  )

interface WorkspacesRouteRouteChildren {
  WorkspacesWorkspaceIdRouteRoute: typeof WorkspacesWorkspaceIdRouteRouteWithChildren
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
}

const WorkspacesRouteRouteChildren: WorkspacesRouteRouteChildren = {
  WorkspacesWorkspaceIdRouteRoute: WorkspacesWorkspaceIdRouteRouteWithChildren,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
}

const WorkspacesRouteRouteWithChildren = WorkspacesRouteRoute._addFileChildren(
  WorkspacesRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KnowledgeRouteRoute: KnowledgeRouteRouteWithChildren,
  WorkspacesRouteRoute: WorkspacesRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  DataAndPrivacyRoute: DataAndPrivacyRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PersonalInformationRoute: PersonalInformationRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  BillingCallbackRoute: BillingCallbackRoute,
  BillingIndexRoute: BillingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
